import {t} from "../../../../shared/services/i18n";

export const FREQUENCY_COLUMN_LABEL_KEYS = {
    1: 'courseLimitations1xWeek',
    2: 'courseLimitations2xWeek',
    3: 'courseLimitations3xWeek',
    4: 'courseLimitations4xWeek',
    5: 'courseLimitations5xWeek',
    6: 'courseLimitations6xWeek',
    7: 'courseLimitations7xWeek',
};

export const SESSION_PER_WEEK_COURSE_OPTIONS = [1,2,3,4,5,6,7]
export const SESSION_PER_WEEK_OPTIONS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20]

export const getSessionPerWeekFilterOptions = () =>
    SESSION_PER_WEEK_OPTIONS.map(value => ({
            value,
            text: t('session-per-week-label', {sessionPerWeek: value})
    }))
